import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import DataguardRoles from '../DataguardRoles';
import VennLegend from '../VennLegend';
import FullscreenIcon from "@material-ui/icons/Fullscreen";

const RolesCard = ({ showExpandedView, onClick, isPopup = false, style }) => {
  const [totalActiveUsers, setTotalActiveUsers] = useState(0);
  const [totalInactiveUsers, setTotalInactiveUsers] = useState(0);
  const rolesData = useSelector((state) => state.DataguardReducer.rolesData);

  useEffect(() => {
    if (rolesData) {
      setTotalActiveUsers(rolesData.activeUsers);
      setTotalInactiveUsers(rolesData.inactiveUsers);
    }
  }, [rolesData]);

  return (
    <div className="column-card roles-card" style={style}>
      <div className='details-container' onClick={onClick}>
        <div className='left-details'>
          <div className='left-details-container'>
            <div className='icon-container'>
              <img src='/dataguardIcons/roles.svg' alt='Roles Icon' />
              <span className='ico-label'>Roles</span>
            </div>
            <div className='left-details-txt'>
              <span>Total # of Active Users</span>
              <span className='no-locs'>{totalActiveUsers || 0}</span>
            </div>
            <div className='left-details-txt'>
              <span>Total # of Inactive Users</span>
              <span className='loc-alert'>{totalInactiveUsers || 0}</span>
            </div>
            {isPopup && <div className='venn-legend venn-legend-popup'>
              <VennLegend />
            </div>}
          </div>
        </div>
        <div className='right-chart'>
          <DataguardRoles />
        </div>
      </div>
      {!isPopup && <div className='venn-legend venn-legend-card'>
        <VennLegend />
      </div>}
      {!isPopup ? (
        <div className='fullscreen-icon roles' onClick={(e) => { showExpandedView('roles'); e.stopPropagation(); }}>
          <FullscreenIcon fontSize="small" />
        </div>
      ) : (
        null
      )}
    </div>
  );
};

export default RolesCard;